import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../auth/AuthContext";

const friendlyError = (detail) => {
  const d = (detail || "").toLowerCase();
  if (d.includes("already used")) return "This sign-in link has already been used. Please request a new one.";
  if (d.includes("expired")) return "This sign-in link has expired. Please request a new one.";
  if (d.includes("invalid")) return "This sign-in link is invalid. Please request a new one.";
  return "We could not sign you in right now. Please try again.";
};

export default function VerifyMagic() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [state, setState] = useState("verifying"); // verifying | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const token = params.get("token");
    if (!token) {
      setMessage("This sign-in link is missing its token. Please request a new link.");
      setState("error");
      return;
    }

    api
      .post("/auth/magic-link/verify", { token })
      .then((r) => {
        localStorage.setItem("wp_token", r.data.access_token);
        setUser(r.data.user);
        navigate("/app", { replace: true, state: { user: r.data.user } });
      })
      .catch((e) => {
        setMessage(friendlyError(e.response?.data?.detail));
        setState("error");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#08080A] px-5" data-testid="verify-magic-page">
      <div className="w-full max-w-sm rounded-3xl border border-white/10 bg-[#14141A]/90 p-10 text-center backdrop-blur-xl">
        <img src="/winter-logo.jpg" alt="Winter Protocol" className="mx-auto h-12 w-12 rounded-xl object-cover mix-blend-screen" />
        {state === "verifying" ? (
          <>
            <span className="mx-auto mt-6 block h-6 w-6 animate-spin rounded-full border-2 border-[#D4AF37]/30 border-t-[#D4AF37]" />
            <p className="mt-4 font-mono text-xs tracking-[0.25em] text-[#636B78] uppercase" data-testid="verify-status">
              Verifying your link…
            </p>
          </>
        ) : (
          <>
            <p className="mt-6 font-display text-lg font-semibold text-white">Sign-in link problem</p>
            <p className="mt-2 text-sm leading-relaxed text-[#99A1AF]" data-testid="verify-error-message">{message}</p>
            <Link
              to="/login"
              data-testid="verify-back-to-login"
              className="mt-6 inline-block rounded-full bg-[#D4AF37] px-6 py-3 text-sm font-semibold text-[#08080A] transition-colors hover:bg-[#F3E5AB]"
            >
              Back to Login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
